/**
 * 根据 window.PAGE_DATA.common.lang 语种信息判断当前是否为 RTL 语种
 */
export function isRTL() {
  const lang =
    window.PAGE_DATA &&
    window.PAGE_DATA.common &&
    window.PAGE_DATA.common.lang;
  return lang == 'ar_SA' || lang == 'iw_IL';
}

/**
 * DX 跳转手动对 URL 增加 spm 参数（aplus） 
 * @param {string} url - 一般为跳转链接的 URL
 * @param {string} clickSPM - SPM (a2706.b.c.d)
 */
export function addClickSPMToURL(url, clickSPM) {
  if (!clickSPM) {
    return url;
  }

  try {
    if (url.startsWith('//')) {
      // "https:" + "//www.alibaba.com/xxxxx"
      url = window.location.protocol + url;
    } else if (url.startsWith('/')) {
      // "https://m.alibaba.com" + "/Categories?language=en&countryId=CN"
      url = window.location.origin + url;
    }

    let urlObject = new URL(url);
    urlObject.searchParams.set('spm', clickSPM);
    url = urlObject.toString();
  } catch (e) {
    console.error('DX Click - Url 解析错误：', url);
  }
  return url;
}

/**
 * FreePage 楼层数据中的 traceInfo 提取点击区块打点名（即 name）
 * @param {object} traceInfo - 打点数据结构
 * 
 * "traceInfo": {
 *  "name": "20marchMain",
 *    "param": {...}
 *  }
 * }
 */
export function getClickSPMFromTraceInfo(traceInfo) {
  const traceName = traceInfo && traceInfo.name;
  if (!traceName || traceName.length < 1) {
    return null;
  }

  const spm_ab = (window.goldlog && window.goldlog.spm_ab.join('.')) || 'a2706.8172434';
  const randomStr = Math.random().toString(36).substring(3);
  return `${spm_ab}.${traceName}.0.${randomStr}`;
}

// view 渲染前绑定上下文，使所有控件均可在渲染结束后调用 calc
export function setIndexMapContext() {
  const { _id, _tplContext } = this.props;
  const { componentIndexSet } = _tplContext;

  for (let i = componentIndexSet.length - 1;i >= 0;i--) {
    const { id } = componentIndexSet[i];

    if (id === _id) {
      componentIndexSet[i].context = this;
      return;
    }
  }
}